export default "__VITE_ASSET__2VRik5NG__"